import { mapPlaylistPreviewObject } from "./mappers";
import { http } from "../client";
export var searchPlaylists = function (request) {
    return http.api
        .get("playlists/search", {
        params: {
            title: request.title,
            client_id: request.clientId,
            publicity: request.type,
            skip: request.skip,
            take: request.limit,
        },
    })
        .then(function (response) { return response.data; })
        .then(function (_a) {
        var _b = _a.data, items = _b.items, total = _b.total;
        return {
            playlists: items.map(mapPlaylistPreviewObject),
            total: total,
        };
    });
};
